import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown, faFlag, faShareAlt } from "@fortawesome/free-solid-svg-icons";
import dummyAd from "./dummyad.jpg";
import dummyPlaceholder from "./dummylitenshortimg.jpg";
import { useSwipeable } from "react-swipeable";

const categories = ["MSME", "Gaon2Global", "BlueHands", "Shakti", "Matrika", "Golden7", "GenZ", "Ageless", "Legend", "Googly", "Chemistry"];

const dummyNews = {
  MSME: [
    {
      title: "Government Launches MSME Support Portal",
      image: "https://via.placeholder.com/400x250",
      content:
        "The Indian government has unveiled a new MSME support portal to help small and medium enterprises connect with investors and suppliers easily.",
      source: "https://www.msmemagazine.in",
      date: "Oct 10, 2025",
    },
    {
      title: "Digital Loans for MSMEs Grow 35%",
      image: "https://via.placeholder.com/400x250",
      content:
        "Digital lending platforms have reported a 35% increase in loan disbursals to MSMEs as more businesses embrace fintech solutions.",
      source: "https://www.fintechnews.in",
      date: "Oct 8, 2025",
    },
    {
      title: "Skill Up Program for MSME Owners",
      image: "https://via.placeholder.com/400x250",
      content:
        "A new ‘Skill Up India’ initiative will train MSME owners on digital marketing and export readiness to boost growth opportunities.",
      source: "https://www.msmetimes.com",
      date: "Oct 6, 2025",
    },
    {
      title: "Export Policy Reforms Benefit MSMEs",
      image: "https://via.placeholder.com/400x250",
      content:
        "The new export policy has reduced compliance requirements for MSMEs, making cross-border trade more accessible.",
      source: "https://www.tradeconnect.in",
      date: "Oct 5, 2025",
    },
    {
      title: "MSME Cluster Parks to Generate Jobs",
      image: "https://via.placeholder.com/400x250",
      content:
        "The government is setting up MSME industrial parks across states to create localized employment and boost manufacturing.",
      source: "https://www.industrybuzz.in",
      date: "Oct 3, 2025",
    },
  ],
  BlueHands: [
    {
      title: "New Health Plan for Blue-Collar Workers",
      image: "https://via.placeholder.com/400x250",
      content:
        "A new affordable health plan will cover medical expenses and accidents for blue-collar workers across industrial belts.",
      source: "https://www.labournews.in",
      date: "Oct 9, 2025",
    },
    {
      title: "Skill Certification Scheme Launched",
      image: "https://via.placeholder.com/400x250",
      content:
        "The Ministry of Labour has announced a certification scheme to improve the employability of blue-collar workers.",
      source: "https://www.skillindia.in",
      date: "Oct 8, 2025",
    },
    {
      title: "New Housing Policy for Workers",
      image: "https://via.placeholder.com/400x250",
      content:
        "Affordable rental housing schemes are being launched to benefit migrant blue-collar workers in metro areas.",
      source: "https://www.cityhousing.gov.in",
      date: "Oct 7, 2025",
    },
    {
      title: "Digital Payment Training Drive",
      image: "https://via.placeholder.com/400x250",
      content:
        "Workers in the informal sector are being trained to use UPI and digital wallets for safer transactions.",
      source: "https://www.financialexpress.in",
      date: "Oct 6, 2025",
    },
    {
      title: "Wage Code Reforms Passed",
      image: "https://via.placeholder.com/400x250",
      content:
        "New wage code reforms have standardized minimum wages and improved overtime benefits for blue-collar workers.",
      source: "https://www.economictimes.com",
      date: "Oct 5, 2025",
    },
  ],
  Matrika: [
    {
      title: "Nutrition Tips for Pre-Schoolers",
      image: "https://via.placeholder.com/400x250",
      content:
        "Health experts share simple nutrition tips for mothers of pre-schoolers to boost immunity and focus.",
      source: "https://www.parentingnow.in",
      date: "Oct 10, 2025",
    },
    {
      title: "Mindful Motherhood Initiative",
      image: "https://via.placeholder.com/400x250",
      content:
        "A new digital platform helps mothers practice mindfulness and stress management through guided sessions.",
      source: "https://www.mothercircle.org",
      date: "Oct 9, 2025",
    },
    {
      title: "Affordable Preschooling Options",
      image: "https://via.placeholder.com/400x250",
      content:
        "Parents can now access a list of affordable yet quality preschooling options in metro and tier-2 cities.",
      source: "https://www.educationtoday.in",
      date: "Oct 8, 2025",
    },
    {
      title: "Working Moms Get Flexible Hours",
      image: "https://via.placeholder.com/400x250",
      content:
        "Companies are introducing flexible working hours and childcare support for young mothers post-pandemic.",
      source: "https://www.worklifebalance.in",
      date: "Oct 7, 2025",
    },
    {
      title: "Storytelling for Bonding",
      image: "https://via.placeholder.com/400x250",
      content:
        "Experts say storytelling helps improve emotional bonding and creativity among preschool-age children.",
      source: "https://www.parentspeak.in",
      date: "Oct 6, 2025",
    },
  ],
  Golden7: [
    {
      title: "Teens Launch Climate Campaign",
      image: "https://via.placeholder.com/400x250",
      content:
        "A group of teenagers has launched a climate awareness campaign to encourage eco-friendly habits in schools.",
      source: "https://www.youthvoice.in",
      date: "Oct 10, 2025",
    },
    {
      title: "Coding Clubs for Teens Rise",
      image: "https://via.placeholder.com/400x250",
      content:
        "Coding clubs across India are attracting teenagers eager to learn AI, robotics, and app development.",
      source: "https://www.techstudent.in",
      date: "Oct 8, 2025",
    },
    {
      title: "Sports Scholarships Expanded",
      image: "https://via.placeholder.com/400x250",
      content:
        "Sports federations are expanding scholarships for teens showing exceptional athletic performance.",
      source: "https://www.sportstar.in",
      date: "Oct 7, 2025",
    },
    {
      title: "Teen Entrepreneurs Win Awards",
      image: "https://via.placeholder.com/400x250",
      content:
        "Young entrepreneurs are making headlines with their innovative startup ideas in school-level competitions.",
      source: "https://www.startupbeat.in",
      date: "Oct 6, 2025",
    },
    {
      title: "AI Literacy Program Launched",
      image: "https://via.placeholder.com/400x250",
      content:
        "AI literacy is now being introduced in high schools to prepare students for future-ready careers.",
      source: "https://www.edtechfocus.in",
      date: "Oct 5, 2025",
    },
  ],
  Ageless: [
    {
      title: "New Health Insurance Plan for Seniors",
      image: "https://via.placeholder.com/400x250",
      content:
        "A special health insurance plan now covers preventive checkups and at-home doctor visits for senior citizens.",
      source: "https://www.healthfirst.in",
      date: "Oct 9, 2025",
    },
    {
      title: "Silver Tech Workshops Begin",
      image: "https://via.placeholder.com/400x250",
      content:
        "Digital literacy workshops are helping seniors become confident in using smartphones and social media.",
      source: "https://www.silversociety.in",
      date: "Oct 8, 2025",
    },
    {
      title: "Senior Clubs Gain Popularity",
      image: "https://via.placeholder.com/400x250",
      content:
        "Senior citizen clubs are becoming community hubs offering wellness, travel, and learning activities.",
      source: "https://www.lifebeyond60.in",
      date: "Oct 7, 2025",
    },
    {
      title: "Online Yoga for Seniors",
      image: "https://via.placeholder.com/400x250",
      content:
        "Virtual yoga sessions designed for seniors focus on flexibility, balance, and relaxation.",
      source: "https://www.healthline.in",
      date: "Oct 6, 2025",
    },
    {
      title: "Age is Just a Number Movement",
      image: "https://via.placeholder.com/400x250",
      content:
        "Seniors across India are joining the ‘Age is Just a Number’ movement to inspire active living.",
      source: "https://www.agelessspirit.in",
      date: "Oct 5, 2025",
    },
  ],
  Gaon2Global: [
    {
      title: "Record Increase in Organic Farming",
      image: "https://via.placeholder.com/400x250",
      content:
        "Farmers across multiple states report a strong shift toward organic cultivation driven by rising market demand and government incentives.",
      source: "https://www.krishinews.in",
      date: "Oct 9, 2025",
    },
    {
      title: "Solar-Powered Irrigation Expands",
      image: "https://via.placeholder.com/400x250",
      content:
        "Rural districts are adopting solar irrigation pumps, reducing diesel dependency and lowering irrigation costs for small farmers.",
      source: "https://www.ruralenergyupdate.in",
      date: "Oct 8, 2025",
    },
    {
      title: "FPOs Boost Market Access",
      image: "https://via.placeholder.com/400x250",
      content:
        "Farmer Producer Organizations are helping farmers get better prices by enabling direct sales to bulk buyers and mandis.",
      source: "https://www.agrimarketwatch.in",
      date: "Oct 7, 2025",
    },
    {
      title: "Smart Soil Testing Vans Launched",
      image: "https://via.placeholder.com/400x250",
      content:
        "Mobile soil testing labs are reaching remote villages, providing instant fertility reports and crop-specific nutrient advice.",
      source: "https://www.soilhealthmission.in",
      date: "Oct 6, 2025",
    },
    {
      title: "Rural Women Lead Food Processing Units",
      image: "https://via.placeholder.com/400x250",
      content:
        "Self-help groups are establishing micro food-processing units for pickles, millets, spices, and local produce under PMFME support.",
      source: "https://www.gaoninnovation.in",
      date: "Oct 5, 2025",
    },
  ],
  Shakti: [
    {
      title: "Women-Led Startups See Record Growth",
      image: "https://via.placeholder.com/400x250",
      content:
        "Funding for women-led startups has increased significantly, with new government schemes supporting innovation in agriculture, health, textiles, and digital services.",
      source: "https://www.startupwomen.in",
      date: "Oct 9, 2025",
    },
    {
      title: "Digital Skills Training for Rural Women",
      image: "https://via.placeholder.com/400x250",
      content:
        "Thousands of rural women are joining digital literacy camps where they learn mobile payments, online business tools, and basic coding.",
      source: "https://www.ruraltechshakti.in",
      date: "Oct 8, 2025",
    },
    {
      title: "Women SHGs Launch New Food Brands",
      image: "https://via.placeholder.com/400x250",
      content:
        "Self-Help Groups across states are launching branded millet snacks, spices, pickles, and regional foods with support from the PMFME scheme.",
      source: "https://www.shgupdates.in",
      date: "Oct 7, 2025",
    },
    {
      title: "New Health Screening Vans for Women",
      image: "https://via.placeholder.com/400x250",
      content:
        "Mobile medical vans offering breast cancer, anemia, and general health screenings are being deployed in districts with low access to health facilities.",
      source: "https://www.healthmission.in",
      date: "Oct 6, 2025",
    },
    {
      title: "Women in Policing Increase Across States",
      image: "https://via.placeholder.com/400x250",
      content:
        "Several states are increasing the representation of women in police forces, focusing on community policing and safety cells for women.",
      source: "https://www.indiasafetynews.in",
      date: "Oct 5, 2025",
    },
  ],
  Legend: [
  {
    title: "Supreme Court Sets Landmark Precedent on Digital Privacy Rights",
    image: "https://via.placeholder.com/400x250",
    content:
      "In a significant judgment, the Supreme Court reaffirmed digital privacy as a fundamental right, directing institutions to adopt stronger data-protection and consent-based frameworks.",
    source: "https://www.scobserver.in",
    date: "Nov 18, 2025",
  }
],
Googly: [
  {
    title: "Rookie Spinner Shocks Australia With Match-Winning Googly Spell",
    image: "https://via.placeholder.com/400x250",
    content:
      "In a memorable debut, India’s young leg-spinner delivered a stunning spell of googlies, turning the match on its head and leading India to a dramatic final-over victory.",
    source: "https://www.espncricinfo.com",
    date: "Nov 25, 2025",
  }
],
Chemistry: [
  {
    title: "India Launches National Chemistry Innovation Mission",
    image: "https://via.placeholder.com/400x250",
    content:
      "The government has announced a National Chemistry Innovation Mission to promote advanced research in green chemistry, sustainable materials, and pharmaceutical sciences.",
    source: "https://www.chemistryworld.com",
    date: "Oct 10, 2025",
  },
  {
    title: "Green Chemistry Startups Attract Record Funding",
    image: "https://via.placeholder.com/400x250",
    content:
      "Investors are increasingly backing green chemistry startups focused on biodegradable plastics, clean energy storage, and eco-friendly industrial processes.",
    source: "https://www.sciencenews.org",
    date: "Oct 8, 2025",
  },
  {
    title: "AI Accelerates Drug Discovery in Chemistry Labs",
    image: "https://via.placeholder.com/400x250",
    content:
      "Researchers are leveraging AI-powered molecular simulations to reduce drug discovery timelines and improve compound prediction accuracy.",
    source: "https://www.nature.com",
    date: "Oct 6, 2025",
  },
  {
    title: "New Battery Chemistry Promises Faster EV Charging",
    image: "https://via.placeholder.com/400x250",
    content:
      "Scientists have developed a novel lithium-silicon battery chemistry that could significantly reduce electric vehicle charging time while improving lifespan.",
    source: "https://www.energytechreview.com",
    date: "Oct 5, 2025",
  },
  {
    title: "National Chemistry Olympiad Sees Record Participation",
    image: "https://via.placeholder.com/400x250",
    content:
      "This year’s Chemistry Olympiad recorded the highest student participation, reflecting growing interest in chemical sciences among young learners.",
    source: "https://www.educationtoday.in",
    date: "Oct 3, 2025",
  },
],
};

const LiteNShortHome = () => {
  const [category, setCategory] = useState("MSME");
  const [index, setIndex] = useState(0);
  const [showAd, setShowAd] = useState(false);
  const [flagged, setFlagged] = useState({});
  const newsList = dummyNews[category];

  const showNextNews = useCallback(() => {
    setShowAd(true);
    setTimeout(() => {
      setShowAd(false);
      setIndex((prev) => (prev + 1) % newsList.length);
    }, 2000);
  }, [newsList]);

  const showPrevNews = useCallback(() => {
    setShowAd(true);
    setTimeout(() => {
      setShowAd(false);
      setIndex((prev) => (prev - 1 + newsList.length) % newsList.length);
    }, 2000);
  }, [newsList]);

  const toggleFlag = () => {
    setFlagged((prev) => ({
      ...prev,
      [`${category}-${index}`]: !prev[`${category}-${index}`],
    }));
  };

  const handleShare = async () => {
    const current = newsList[index];
    try {
      if (navigator.share) {
        await navigator.share({
          title: current.title,
          text: current.content,
          url: current.source,
        });
      } else {
        alert("Share not supported on this device");
      }
    } catch (err) {
      // console.log("Share cancelled", err);
    }
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowDown") showNextNews();
      if (e.key === "ArrowUp") showPrevNews();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [showNextNews, showPrevNews]);

  const handlers = useSwipeable({
    onSwipedUp: showNextNews,
    onSwipedDown: showPrevNews,
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
  });

  const current = newsList[index];

  if (showAd) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-black text-white">
        <img
          src={dummyAd}
          alt="Sponsored Ad"
          className="w-full max-w-sm rounded-xl shadow-lg object-cover"
        />
        <div className="text-center mt-4 px-4">
          <p className="text-lg font-semibold text-orange-400">Sponsored Content</p>
          <p className="text-gray-400 text-sm mt-1">
            Discover offers, tools, and updates from our partners.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      {...handlers}
      className="bg-black text-white h-screen flex flex-col items-center justify-between p-2"
    >
      <div className="grid grid-cols-5 lg:grid-cols-8 gap-1 w-full place-items-center">
        {categories.map((cat) => {
          const isSelected = cat === category;

          return (
            <button
              key={cat}
              onClick={() => {
                setCategory(cat);
                setIndex(0);
              }}
              className={[
                "w-full text-center rounded-sm font-medium select-none",
                "px-1.5 py-2 text-[10px] lg:text-xs leading-tight",
                "transition-all duration-150",
                !isSelected &&
                  "bg-blue-100 text-gray-700 hover:bg-blue-300 hover:text-white active:bg-blue-400",
                isSelected &&
                  "bg-blue-600 text-white shadow-sm active:bg-blue-700",
              ].join(" ")}
            >
              {cat}
            </button>
          );
        })}
      </div>

      <div className="my-2 w-full flex justify-center">
        <img
          src={dummyPlaceholder}  
          alt={current.title}
          className="rounded-lg w-full max-w-md"
        />
      </div>

      <div className="flex-1 flex flex-col text-center border bg-black px-4 py-4 rounded-lg w-full max-w-md">
        <h2 className="text-lg font-semibold mb-2 text-yellow-200">{current.title}</h2>
        <p className="text-white text-sm mb-3">{current.content}</p>
      </div>

      <div className="flex flex-col justify-between items-center w-full max-w-md mt-2 text-sm">
        <div className="flex justify-center gap-6 mt-0 mb-1">
            <FontAwesomeIcon
              icon={faChevronUp}
              className="text-gray-400 cursor-pointer"
              size="2x"
              onClick={showPrevNews}
            />
            <FontAwesomeIcon
              icon={faChevronDown}
              className="text-gray-400 cursor-pointer"
              size="2x"
              onClick={showNextNews}
            />
        </div>
        <div className="flex justify-between items-center w-full text-xs text-gray-400 mt-2">
          <div>{current.date}</div>
          <a
            href={current.source}
            target="_blank"
            rel="noopener noreferrer"
            className="text-orange-400 underline"
          >
            Source
          </a>
          <div className="flex gap-3">
            <FontAwesomeIcon
                icon={faFlag}
                className={`cursor-pointer ${
                flagged[`${category}-${index}`] ? "text-green-400" : "text-white"
                }`}
                onClick={toggleFlag}
                size="lg"
            />
            <FontAwesomeIcon
                icon={faShareAlt}
                className="cursor-pointer text-white"
                onClick={handleShare}
                size="lg"
            />
          </div>
        </div>
        <div className="mt-2 mb-16">
          <span className="text-blue-400">Lite</span>
          <span className="text-orange-400">N</span>
          <span className="text-blue-400">Short</span>
          <span className="text-yellow-200"> By Think5Whys</span>
        </div>
      </div>
    </div>
  );
};

export default LiteNShortHome;
